import { useState, useEffect, useRef, useContext } from 'react';
import "../Login/UserProfile/style.css";
import { FilterWrapper, TableWrapper } from '../UI/styledConstants';
import { getTransactionHistoryRequest } from '../../utils/api';
import Pagination from '../Pagination/Pagination';
import { getCurrentDate, isEmpty, pdfData } from '../../utils/common';
import LocalLoader from '../UI/Loader/LocalLoader';
import { CSVLink } from 'react-csv';
import { GlobleContaxt } from '../../Context/GlobleContaxt';
import TransactionReceipt from './TransactionReceipt';
import { ServiceBoxWrapper } from '../ServicesBox/style';
import bbpsLogo2 from '../../assets/images/BBPS3.svg';
import Back from '../UIbox/Back';

const TransactionHistory = () => {
	const [transactionHistory, setTransactionHistory] = useState([]);
	const [downloadLoader, setDownloadLoader] = useState('');
	const [userUUid, setUserUUid] = useState('');
	const [filter, setFilter] = useState({
		pageNo: 0,
		pageSize: 10,
		fromDate: '',
		toDate: '',
		transactionType: 'SEND_MONEY',
		txnId: '',
		status: null,
	});

	const [paging_data, setPagingData] = useState(null);
	const [history, setHistory] = useState({});
	const [loading, setLoading] = useState(null);
	const [totalElement, setTotalElement] = useState('');
	const [csvData, setCsvData] = useState([]);

	const { userDetails } = useContext(GlobleContaxt);

	const getTransactionHistory = (key) => {
		let params = {
			serviceType: filter.transactionType,
			fromDate: filter.fromDate,
			toDate: filter.toDate,
			//txnId: filter.txnId,
			//status: filter.status,
			//transactionType: "",
			//transactionMode: "",
			transactionId: filter.txnId,
			userUuid: userUUid,
			pagination: {
				pageNo: filter.pageNo,
				pageSize: filter.pageSize,
			},
		};

		if (key === 'csv' || key === 'pdf') {
			if (key === 'csv') {
				setDownloadLoader('csv');
			} else {
				setDownloadLoader('pdf');
			}
			params.pagination.pageSize = totalElement;
		} else {
			params.pagination.pageSize = 10;
			setLoading(true);
		}

		getTransactionHistoryRequest(params).then((resp) => {
			setLoading(false);
			setDownloadLoader('');
			if (resp?.success) {
				if (key !== 'csv' && key !== 'pdf') {
					setTransactionHistory(resp?.data?.content);
					setTotalElement(resp?.data?.totalElements);
					setPagingData({
						number: resp?.data?.number,
						totalPages: resp?.data?.totalPages,
					});
				} else if (key === 'csv') {
					setCsvData(resp?.data?.content);
					const csvlink = link.current;
					csvlink.link.click();
				} else if (key === 'pdf') {
					setCsvData(resp?.data?.content);
					pdfDownload(resp?.data?.content);
				}
			} else {
				setTransactionHistory([]);
			}
		});
	};

	const filterChangeHandler = (e) => {
		const { name, value } = e.target;
		if (name === 'transactionType') {
			setFilter({
				pageNo: 0,
				pageSize: 10,
				fromDate: '',
				toDate: '',
				transactionType: value,
				txnId: '',
			});
		} else {
			setFilter({ ...filter, [name]: value, pageNo: 0 });
		}
	};

	useEffect(() => {
		if (userUUid !== '') {
			getTransactionHistory('');
		}
	}, [filter.transactionType, filter.pageNo, userUUid]);

	useEffect(() => {
		if (!isEmpty(userDetails.uuid) && userUUid === '') {
			setUserUUid(userDetails.uuid);
		}
	}, [userDetails.uuid]);

	const showUsername = filter.transactionType === 'PREPAID_RECHARGE';

	const options = [
		{ value: 'SEND_MONEY', label: 'Send Money' },
		{ value: 'PREPAID_RECHARGE', label: 'Prepaid Recharge' },
		{ value: 'AEPS', label: 'AEPS' },
		{ value: 'ELECTRICITY', label: 'Electricity' },
		{ value: 'SETTLEMENT', label: 'Settlement' },
		{ value: 'WATER', label: 'Water' },
		{ value: 'PAY_OUT', label: 'Payout' },
		{ value: 'BBPS', label: 'BBPS' },
		{ value: 'UPI_PAY', label: 'UPI' },
		{ value: 'TRAVEL', label: 'Travel' },
		{ value: 'POS', label: 'POS' },
	];

	const link = useRef(null);

	const pdfDownload = (data) => {
		const tableHeader = [];

		if (!showUsername) {
			tableHeader.push({
				accountNumber: 'Merchant Name',
				transactionId: 'Transaction Id',
				transactionDate: 'Date',
				status: 'Status',
				amount: 'Amount',
			});
		} else {
			tableHeader.push({
				rechargedNumber: 'Merchant Name',
				transactionId: 'Transaction Id',
				transactionDate: 'Date',
				status: 'Status',
				amount: 'Amount',
			});
		}

		pdfData(data, tableHeader, 'Transaction History');
	};

	function closePop() {
		setHistory({});
	}

	return (
		<>
			<div className='container'>
				
				<ServiceBoxWrapper className='bbps'>
							<div className="header flex justify-between items-center">
							<Back url="/" />
								<h2 className="m0">Transaction History </h2>
								<div>
									{/* <img src={bbpsLogo2} alt="bbps logo" /> */}
								</div>
							</div>
							<div className="service-box-body">
							<div className="flex">
					<div className="personal-information transaction">
						<FilterWrapper className="flex items-center justify-between">
							<div className="filterBox">
								<div className="filter-text">Filter By</div>

								<div className="input-field">
									<select placeholder="Select transactionType" value={filter.transactionType} defaultValue={'PREPAID_RECHARGE'} name="transactionType" onChange={filterChangeHandler}>
										{options.map((val, index) => {
											return (
												<option key={index} value={val.value}>
													{val.label}
												</option>
											);
										})}
									</select>
								</div>
								<div className="input-field">
									<input type="text" name="txnId" placeholder="Transaction Id" value={filter.txnId} onChange={filterChangeHandler} />
								</div>

								<div className="input-field date-filter" style={{overflow:"hidden"}}>
									{/* <img className='img-1' src={calanderIcon} alt='calanderIcon' />
							     <select>
									<option>Main Wallet</option>
									<option >AEPS Wallet</option>
								 </select>
								 <img className='img-2' src={calanderIcon} alt='calanderIcon' /> */}
									<input type="date" placeholder="From" name="fromDate" value={filter.fromDate} onChange={filterChangeHandler} />
									{/* <img className='img-3' src={calanderIcon} alt='calanderIcon' /> */}
									<input type="date" placeholder="To" name="toDate" value={filter.toDate} min={filter.fromDate} onChange={filterChangeHandler} disabled={isEmpty(filter.fromDate)} />
								</div>
								<div className="input-field">
									<button className="filterButton" onClick={() => getTransactionHistory('')}>
										GO
									</button>
									{downloadLoader !== 'csv' ? (
										<button className="filterButton" onClick={() => getTransactionHistory('csv')}>
											CSV
										</button>
									) : (
										<button className="filterButton btn-loader" onClick={() => getTransactionHistory('pdf')}>
											<div className="btn-loader">
												<i className="fa-solid fa-spinner"></i>
											</div>
										</button>
									)}
									{downloadLoader !== 'pdf' ? (
										<button className="filterButton" onClick={() => getTransactionHistory('pdf')}>
											PDF
										</button>
									) : (
										<button className="filterButton btn-loader" onClick={() => getTransactionHistory('pdf')}>
											<div className="btn-loader">
												<i className="fa-solid fa-spinner"></i>
											</div>
										</button>
									)}
									<CSVLink ref={link} data={csvData} filename={'Transaction-History.csv'}></CSVLink>
								</div>
							</div>
						</FilterWrapper>

						<TableWrapper className="mt20 table-card-wrapper">
							{loading && <LocalLoader className="tableLoader" />}
							<table className="table">
								<thead className="table-head">
									<tr>
										<th>Reatiler Name</th>
										<th>Reatiler No.</th>
										{
											<th>
												{filter.transactionType === 'PREPAID_RECHARGE'
													? 'Recharge Number'
													: filter.transactionType === 'AEPS' || filter.transactionType === 'BBPS'
													? 'Account Number'
													: 'Account Holder Name'}
											</th>
										}
										{filter.transactionType === 'SEND_MONEY' && <th>Account Number </th>}

										{filter.transactionType !== 'AEPS' ||
											(filter.transactionType !== 'BBPS' && (
												<th>
													{filter.transactionType === 'PREPAID_RECHARGE'
														? 'Operator Code'
														: filter.transactionType === 'DTH'
														? 'Operator Code'
														: filter.transactionType === 'AEPS'
														? 'Order Id'
														: 'Account IFSC Code'}
												</th>
											))}
										{(filter.transactionType === 'BBPS' || filter.transactionType === 'SEND_MONEY')  && <th>Ref. TransactionId</th>}
										<th>
											{filter.transactionType === 'PREPAID_RECHARGE'
												? 'Transaction Id'
												: filter.transactionType === 'DTH'
												? 'Transaction Id'
												: filter.transactionType === 'AEPS'
												? 'Merchant Transaction Id'
												: filter.transactionType === 'SEND_MONEY'
												? 'Transaction Id'
												: 'Transaction Id'}
										</th>

										<th>Route</th>
										<th>Date and Time</th>
										<th>Amount</th>
										{ filter.transactionType === "AEPS" &&(
                    <>
                    <th>Customer Mobile</th>
                    <th>Customer Aadhaar</th>
                    <th>Customer Balance</th>
                    </>
                  ) }
										<th>Status</th>
										<th>Service Type</th>
										<th>Receipt</th>
									</tr>
								</thead>
								<tbody className="table-body">
									{transactionHistory &&
										transactionHistory.map((item, i) => {
											return (
												<tr key={Math.random() * 1000000}>
													<td>
														<span className="card-th">Retailer Name</span>
														<span>{item?.userFullName}</span>
													</td>
													<td>
														<span className="card-th">Retailer No.</span>
														<span>{item?.userPhoneNumber}</span>
													</td>
													{
														<td>
															<span className="card-th">
																{filter.transactionType === 'PREPAID_RECHARGE'
																	? 'Recharge Number'
																	: filter.transactionType === 'AEPS' || filter.transactionType === 'BBPS'
																	? 'Account Number'
																	: 'Account Holder Name'}
															</span>
															<span>
																{filter.transactionType === 'PREPAID_RECHARGE'
																	? item.rechargedNumber
																	: filter.transactionType === 'DTH'
																	? item.rechargedNumber
																	: filter.transactionType === 'AEPS' || filter.transactionType === 'BBPS'
																	? item.accountNumber
																	: item.accountHolderName}
															</span>
														</td>
													}
													{filter.transactionType === 'SEND_MONEY' && (
														<td>
															<span className="card-th">Account Number</span>
															<span>{item.accountNumber}</span>
														</td>
													)}
													{filter.transactionType !== 'AEPS' ||
														(filter.transactionType !== 'BBPS' && (
															<td>
																<span className="card-th">
																	{filter.transactionType === 'PREPAID_RECHARGE'
																		? 'Operator Code'
																		: filter.transactionType === 'DTH'
																		? 'Operator Code'
																		: filter.transactionType === 'AEPS'
																		? 'Order Id'
																		: 'Account IFSC Code'}
																</span>
																<span>
																	{filter.transactionType === 'PREPAID_RECHARGE'
																		? item.operatorCode
																		: filter.transactionType === 'DTH'
																		? item.operatorCode
																		: item.accountIfscCode}
																</span>
															</td>
														))}
													{(filter.transactionType === 'BBPS' || filter.transactionType === 'SEND_MONEY') && (
														<td>
															<span className="card-th">Ref. TransactionId</span>
															<span>{item?.refTransactionId || 'Null'}</span>
														</td>
													)}
													<td>
														<span className="card-th">
															{filter.transactionType === 'PREPAID_RECHARGE'
																? 'Transaction Id'
																: filter.transactionType === 'DTH'
																? 'Transaction Id'
																: filter.transactionType === 'AEPS'
																? 'Merchant Transaction Id'
																: filter.transactionType === 'SEND_MONEY'
																? 'Transaction Id'
																: 'Transaction Id'}
														</span>
														<span>{item?.transactionId || 'Null'}</span>
													</td>
													<td>
														<span className="card-th">Route</span>
														<span>{item?.route}</span>
													</td>
													<td>
														<span className="card-th">Created Date</span>
														<span>{getCurrentDate('', item?.transactionDate, true)}</span>
													</td>
													<td>
														<span className="card-th">Amount</span>
														<span>₹ {item.amount}</span>{' '}
													</td>
													{ filter.transactionType === "AEPS" &&(
                    <>
                    <td>
                    <span className="card-th">Customer Mobile</span>
                    <span>{item?.customerMobile || "-"}</span>
                      </td>
                    <td>
                    <span className="card-th">Customer Aadhaar </span>
                    <span>{item?.aadhaar || "-"}</span>
                      </td>
                    <td>
                    <span className="card-th">Customer Balance</span>
                    <span>{item?.bankAccountBalance || "-"}</span>
                      </td>
                  
                 
                    </>
                  )}
                       
													<td>
														<span className="card-th">Status</span>
														<span>
															<div
																className={`${
																	item.status.toUpperCase() === 'INITIATED' || item.status.toLowerCase() === 'success' || item.status.toLowerCase() === 'done'
																		? 'active_status'
																		: 'inactive_status'
																}`}
																style={item.status.toLowerCase() === 'success' ? { color: 'green' } : { color: 'red' }}
															>
																{item?.status}
															</div>
														</span>
													</td>

													<td>
														<span className="card-th">Service Type</span>
														<span>{item?.serviceType}</span>
													</td>
													<td>
														<span className="card-th">Receipt</span>
														<button className="viewButton" onClick={() => setHistory(item)}>
														<i class="fa-solid fa-eye"></i><span>View</span>
														</button>
													</td>
												</tr>
											);
										})}

									{isEmpty(transactionHistory) && !loading && (
										<tr>
											<td></td>
											<td></td>
											<td></td>
											<td>NO record found</td>
											<td></td>
											<td></td>
											<td></td>
										</tr>
									)}
								</tbody>
							</table>
						</TableWrapper>
						{paging_data && paging_data?.totalPages > 1 && (
							<Pagination currentPage={paging_data?.number} totalPages={paging_data?.totalPages} getCurrentPageData={(page) => setFilter({ ...filter, pageNo: page })} />
						)}
					</div>
				</div>
							</div>
				
			</ServiceBoxWrapper>
			</div>
			{!isEmpty(history) && <TransactionReceipt closePop={closePop} transactionType={filter.transactionType} bankDataResp={history} />}
		</>
	);
};
export default TransactionHistory;
